// extracted by mini-css-extract-plugin
export var footer = "_pf-5";
export var fulfillmentInput = "_pf-0";
export var shipDateInput = "_pf-1";
export var shipmentModal = "_pf-2";
export var shipmentModalContent = "_pf-3";
export var tableContainer = "_pf-4";